module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter01"
    }
  }, [_vm._v("Cast of Major Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Napoléon Takes a Bath")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. What Was the Big Deal About Louisiana, Anyway?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Deal Is Sealed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. What Exactly Did Jefferson Purchase?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The French Claim and Name Louisiana")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. France Gets Kicked Out and Britain Gets the Boot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Napoléon’s Dream Becomes a Nightmare")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Stars and Stripes Finally Fly Over Louisiana")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Lewis and Clark Explore Louisiana")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Under My Wings Every Thing Prospers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("States Formed from the Louisiana Purchase")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bc3a27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 63
// module chunks = 0